import { Button, type ButtonProps, Popover, type SxProps, type Theme } from '@mui/material';
import { type FC, type ReactNode, type Ref, useImperativeHandle, useState } from 'react';

export type ButtonWithPopoverHandleRef = {
  close: () => void;
};

type ButtonWithPopoverProps = ButtonProps & {
  children: ReactNode;
  handle?: Ref<ButtonWithPopoverHandleRef>;
  title?: string;
  paperSx?: SxProps<Theme>;
};

export const ButtonWithPopover: FC<ButtonWithPopoverProps> = ({
  children,
  handle,
  title,
  paperSx,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event): void => {
    props.onClick?.(event);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  useImperativeHandle(
    handle,
    () => ({
      close: handleClose,
    }),
    [handleClose],
  );

  const open = Boolean(anchorEl);
  const id = open ? 'form-popover' : undefined;
  return (
    <>
      <Button {...props} onClick={handleClick} aria-haspopup='dialog'>
        {title}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              background: 'none',
              boxShadow: 'none',
              padding: 0,
              margin: 0,
              ...paperSx,
            },
          },
        }}
      >
        {children}
      </Popover>
    </>
  );
};
